import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

// Defining Show Login Modal Slice
const showAuthSlice = createSlice({
  name: "showAuth",
  initialState,
  reducers: {
    setShowAuth: (state, { payload }) => {
      state.showAuth = payload ?? state.showAuth;
    },
  },
});

export const { setShowAuth } = showAuthSlice.actions;

export default showAuthSlice.reducer;
